export function RowDivider() {
  return <div className="h-px bg-neutrals-200 col-span-full" />;
}
